
const Media = {

  processMedia: (loadedConfiguration = {}, media = {}) => {
    const { progressive: shouldReproduceInProgressive = false, displayTitle = false } = loadedConfiguration;
    return {
      sources: [{
        file: (shouldReproduceInProgressive ? media.progressive : media.m3u8) ?? null,
      }],
      poster: media.thumbnail?.url ?? null,
      thumbnail: media.thumbnail?.url ?? null,    // REVIEW duplicidad
      visualSeeking: media.storyboard ?? null,
      dvr: (media.publicationPoint?.dvr && true) ?? false,
      downloadableSrc: media.progressive ?? null,   // TOFIX ver controllers::fmt-player::Configuration::processConfiguration -> playerBaseConfiguration.download
      srcType: media.type ?? null,
      chapters: media.chapter?.url ?? [],   // ?? null    // REVIEW showChaptersButton showChapterMarkers, TODO REVIEW format
      captions: (media.subtitles?.map( subtitle => ({
        url: subtitle.url,
        label: subtitle.name,
      }))) || [],
    };
  },

};

export default Media;
